import { useState } from "react";
import { Input } from "semantic-ui-react";

import "components/FileDragDrop/FileDragDrop.scss";

type DragEvent = React.DragEvent<HTMLDivElement>;

type FileDragDropProps = {
  id: string;
  onFileUpload: (files: FileList | null) => void;
  required?: boolean;
  accept?: string;
};

export const FileDragDrop = ({ onFileUpload, id, required = true, accept }: FileDragDropProps) => {
  const [draggedOver, setDraggedOver] = useState(false);

  const handleDrop = (evt: DragEvent) => {
    evt.preventDefault();
    setDraggedOver(false);

    const files = evt.dataTransfer?.files;

    if (files && files.length > 0) onFileUpload(files);
  };

  const handleAddFile = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (evt.target.files) {
      onFileUpload(evt.target.files);
    }
  };

  const handleDragEnter = (e: DragEvent) => {
    e.preventDefault();
    setDraggedOver(true);
  };

  const handleDragLeave = () => {
    setDraggedOver(false);
  };

  const handleDragOver = (e: DragEvent) => {
    e.preventDefault();
  };

  const triggerOnChangeOnFileInput = () => {
    document.getElementById(id)?.click();
  };

  return (
    <div
      className={`FileDragDrop ${draggedOver ? "active" : ""}`}
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      <div>
        <span>Drag files here or</span>{" "}
        <span className="browse-text" onClick={triggerOnChangeOnFileInput}>
          Browse
        </span>
      </div>
      <div className="max-file-size">Only XLSX files are allowed</div>
      <Input type="file" id={id} onChange={handleAddFile} placeholder="Browse" multiple required={required} accept={accept} style={{ display: "none" }} />
    </div>
  );
};
